import { PropositionProductTypeValues } from "@dune/types";
import { Input, cn } from "@dune/ui";
import { SearchSm } from "@untitled-ui/icons-react";
import React from "react";

interface ProductTypeTab {
	value: PropositionProductTypeValues | undefined;
	label: string;
	count: number;
}

interface ProductTypeTabsSectionProps {
	productTypeTabs: ProductTypeTab[];
	productTypeFilter: PropositionProductTypeValues | undefined;
	onProductTypeFilterChange: (
		productType: PropositionProductTypeValues | undefined,
	) => void;
	searchInput: string;
	onSearchChange: (value: string) => void;
	searchPlaceholder?: string;
	shouldShow?: boolean;
}

export const ProductTypeTabsSection: React.FC<ProductTypeTabsSectionProps> = ({
	productTypeTabs,
	productTypeFilter,
	onProductTypeFilterChange,
	searchInput,
	onSearchChange,
	searchPlaceholder = "Rechercher par référence, chantier, apporteur...",
	shouldShow = true,
}) => {
	if (!shouldShow) {
		return (
			<div className="flex items-center justify-end">
				<div className="relative w-80">
					<SearchSm className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
					<Input
						placeholder={searchPlaceholder}
						value={searchInput}
						onChange={(e) => onSearchChange(e.target.value)}
						className="pl-10"
					/>
				</div>
			</div>
		);
	}

	return (
		<div className="flex items-center justify-between">
			<div className="flex items-center space-x-4 relative">
				{productTypeTabs.map((tab) => (
					<button
						key={tab.value || "all"}
						type="button"
						onClick={() => onProductTypeFilterChange(tab.value)}
						className={cn(
							"group relative px-3 py-1.5 text-xs font-medium transition-colors flex items-center gap-2",
							productTypeFilter === tab.value
								? "text-primary"
								: "text-gray-500 hover:text-gray-700",
						)}
					>
						{tab.label}
						{tab.count > 0 && (
							<div
								className={cn(
									"flex items-center justify-center w-5 h-5 text-[10px] font-medium rounded-full transition-colors",
									productTypeFilter === tab.value
										? "bg-[#1DD0F4] text-primary-foreground border border-[#01A9CE]"
										: "bg-orange-50 border border-orange-200 text-foreground",
								)}
							>
								{tab.count}
							</div>
						)}
						{productTypeFilter === tab.value && (
							<div className="absolute -bottom-1.5 left-0 right-0 h-0.5 bg-primary rounded-full" />
						)}
					</button>
				))}
			</div>

			<div className="relative w-80">
				<SearchSm className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
				<Input
					placeholder={searchPlaceholder}
					value={searchInput}
					onChange={(e) => onSearchChange(e.target.value)}
					className="pl-10"
				/>
			</div>
		</div>
	);
};

